import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "flex flex-column align-items-center justify-content-center pt-3 pb-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "mb-3 border-solid border-1 surface-border" }, null, -1)
const _hoisted_3 = { class: "grid" }
const _hoisted_4 = { class: "col-12 md:col-6 lg:col-6 p-2" }
const _hoisted_5 = { class: "field" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { for: "item-category" }, "Kategória", -1)
const _hoisted_7 = {
  key: 0,
  class: ""
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "" }
const _hoisted_10 = { class: "field" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { for: "item-product" }, "Produkt", -1)
const _hoisted_12 = { class: "flex align-items-center justify-content-between gap-1" }
const _hoisted_13 = {
  key: 0,
  class: ""
}
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "" }
const _hoisted_16 = { class: "field" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { for: "item-name" }, "Názov", -1)
const _hoisted_18 = { class: "flex justify-content-center" }
const _hoisted_19 = {
  key: 0,
  class: "image-container"
}
const _hoisted_20 = ["src"]
const _hoisted_21 = {
  key: 1,
  class: "image-container placeholder"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-image placeholder-icon" }, null, -1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = { class: "col-12 md:col-6 lg:col-6 p-2" }
const _hoisted_25 = { class: "field" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { for: "item-length" }, "Dĺžka", -1)
const _hoisted_27 = { class: "field" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { for: "item-number" }, "Počet kusov", -1)
const _hoisted_29 = { class: "field" }
const _hoisted_30 = {
  class: "flex align-items-center justify-content-between",
  style: {"margin-bottom":"0.45rem"}
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", { class: "" }, "Farba", -1)
const _hoisted_32 = { class: "flex align-items-center justify-content-right" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", {
  for: "imitation",
  class: "mr-2"
}, "Imitácia dreva", -1)
const _hoisted_34 = {
  key: 0,
  class: "flex align-items-center"
}
const _hoisted_35 = { key: 1 }
const _hoisted_36 = { class: "flex align-items-center" }
const _hoisted_37 = { class: "field" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", { for: "item-type" }, "Typ", -1)
const _hoisted_39 = { class: "field" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", { for: "item-location" }, "Umiestnenie", -1)
const _hoisted_41 = { class: "field mb-3" }
const _hoisted_42 = { class: "flex align-items-center justify-content-left" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", {
  for: "wholePiece",
  class: "ml-2"
}, "Celý kus", -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "mt-3 mb-3 border-solid border-1 surface-border" }, null, -1)
const _hoisted_45 = { class: "mt-2 flex flex-wrap justify-content-center gap-3" }
const _hoisted_46 = { class: "grid" }
const _hoisted_47 = { class: "grid w-full h-full" }
const _hoisted_48 = { class: "col-6 p-2" }
const _hoisted_49 = { class: "text-left font-bold" }
const _hoisted_50 = { class: "text-left mt-5" }
const _hoisted_51 = { class: "col-6 p-1 flex justify-content-center" }
const _hoisted_52 = { class: "w-full h-full flex justify-content-center align-items-center" }
const _hoisted_53 = ["src", "onLoad"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimevueSelect = _resolveComponent("PrimevueSelect")!
  const _component_PrimevueButton = _resolveComponent("PrimevueButton")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_PrimevueCheckbox = _resolveComponent("PrimevueCheckbox")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PrimevueCard = _resolveComponent("PrimevueCard")!
  const _component_PrimevueDialog = _resolveComponent("PrimevueDialog")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PrimevueCard, { class: "sm:w-12 md:w-10 lg:w-8 xl:w-8 mb-2" }, {
      title: _withCtx(() => [
        _createTextVNode("PRIDANIE VIACERÝCH KUSOV")
      ]),
      subtitle: _withCtx(() => [
        _hoisted_2
      ]),
      content: _withCtx(() => [
        _createElementVNode("form", {
          onSubmit: _cache[14] || (_cache[14] = _withModifiers(
//@ts-ignore
(...args) => ($options.submitHandler && $options.submitHandler(...args)), ["prevent"])),
          name: "itemForm"
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createVNode(_component_PrimevueSelect, {
                  id: "item-category",
                  modelValue: $data.selectedCategory,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.selectedCategory) = $event)),
                  options: $data.categories,
                  optionLabel: "name",
                  placeholder: "Vyber kategóriu",
                  class: _normalizeClass(["w-full", `${$setup.v$.selectedCategory.$error ? 'bg-red-200' : ''}`]),
                  invalid: $setup.v$.selectedCategory.$error,
                  onChange: _cache[1] || (_cache[1] = ($event: any) => ($options.selectCategory($data.selectedCategory.id)))
                }, {
                  value: _withCtx((slotProps) => [
                    (slotProps.value.id != 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          _createElementVNode("div", null, _toDisplayString(slotProps.value.name), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(slotProps.placeholder), 1))
                  ]),
                  option: _withCtx((slotProps) => [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", null, _toDisplayString(slotProps.option.name), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "options", "class", "invalid"]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.selectedCategory.$errors, (error, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "text-sm font-italic text-red-400"
                  }, _toDisplayString(error.$message), 1))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_PrimevueSelect, {
                    id: "item-product",
                    disabled: !$data.selectedCategory.name,
                    modelValue: $data.selectedProduct,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($data.selectedProduct) = $event)),
                    filter: "",
                    options: $data.products,
                    optionLabel: "code",
                    placeholder: "Vyber produkt",
                    class: _normalizeClass(["w-full", `${$setup.v$.selectedProduct.$error ? 'bg-red-200' : ''}`]),
                    invalid: $setup.v$.selectedProduct.$error,
                    onChange: _cache[3] || (_cache[3] = ($event: any) => ($options.selectProduct()))
                  }, {
                    value: _withCtx((slotProps) => [
                      (slotProps.value.id != 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            _createElementVNode("div", null, _toDisplayString(slotProps.value.code), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(slotProps.placeholder), 1))
                    ]),
                    option: _withCtx((slotProps) => [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", null, _toDisplayString(slotProps.option.code) + " * " + _toDisplayString(slotProps.option.name), 1)
                      ])
                    ]),
                    _: 1
                  }, 8, ["disabled", "modelValue", "options", "class", "invalid"]),
                  _withDirectives(_createVNode(_component_PrimevueButton, {
                    type: "button",
                    class: "products",
                    icon: "pi pi-table",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (this.visibleProducts = true)),
                    text: "",
                    severity: "primary",
                    size: "large"
                  }, null, 512), [
                    [
                      _directive_tooltip,
                      { value: 'Zobrazenie a výber produktov' },
                      void 0,
                      { top: true }
                    ]
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.selectedProduct.$errors, (error, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "text-sm font-italic text-red-400"
                  }, _toDisplayString(error.$message), 1))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _createVNode(_component_InputText, {
                  class: "w-full",
                  disabled: "",
                  modelValue: $data.stockItem.product.name,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($data.stockItem.product.name) = $event)),
                  type: "text",
                  name: "item-name",
                  id: "item-name"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_18, [
                ($data.stockItem.product.image)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _createElementVNode("img", {
                        src: $data.stockItem.product.image,
                        alt: "Preview Image",
                        class: "preview-image"
                      }, null, 8, _hoisted_20)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_23))
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _hoisted_26,
                _createVNode(_component_InputNumber, {
                  class: "w-full",
                  inputId: "item-length",
                  useGrouping: false,
                  disabled: !($data.selectedCategory.name && $data.selectedProduct.code),
                  modelValue: $data.stockItem.length,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($data.stockItem.length) = $event)),
                  name: "item-length",
                  id: "item-length",
                  inputClass: `${$setup.v$.stockItem.length.$error ? 'bg-red-200' : ''}`,
                  invalid: $setup.v$.stockItem.length.$error
                }, null, 8, ["disabled", "modelValue", "inputClass", "invalid"]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.stockItem.length.$errors, (error, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "text-sm font-italic text-red-400"
                  }, _toDisplayString(error.$message), 1))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_27, [
                _hoisted_28,
                _createVNode(_component_InputNumber, {
                  class: "w-full",
                  inputId: "item-number",
                  useGrouping: false,
                  disabled: !($data.selectedCategory.name && $data.selectedProduct.code),
                  modelValue: $data.numberOfItems,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($data.numberOfItems) = $event)),
                  name: "item-number",
                  id: "item-number",
                  inputClass: `${$setup.v$.numberOfItems.$error ? 'bg-red-200' : ''}`,
                  invalid: $setup.v$.numberOfItems.$error
                }, null, 8, ["disabled", "modelValue", "inputClass", "invalid"]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.numberOfItems.$errors, (error, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "text-sm font-italic text-red-400"
                  }, _toDisplayString(error.$message), 1))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _hoisted_31,
                  _createElementVNode("div", _hoisted_32, [
                    _hoisted_33,
                    _createVNode(_component_PrimevueCheckbox, {
                      modelValue: $data.imitation,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($data.imitation) = $event)),
                      inputId: "imitation",
                      name: "imitation",
                      binary: true,
                      onChange: _cache[9] || (_cache[9] = ($event: any) => ($options.setColors()))
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createVNode(_component_PrimevueSelect, {
                  id: "item-color",
                  disabled: !($data.selectedCategory.name && $data.selectedProduct.code),
                  modelValue: $data.selectedColor,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($data.selectedColor) = $event)),
                  options: $data.colors,
                  optionLabel: "code",
                  placeholder: "Vyber farbu",
                  class: _normalizeClass(["w-full", `${$setup.v$.selectedColor.$error ? 'bg-red-200' : ''}`]),
                  invalid: $setup.v$.selectedColor.$error
                }, {
                  value: _withCtx((slotProps) => [
                    (slotProps.value.id != 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                          _createElementVNode("div", {
                            class: "color-box mr-2",
                            style: _normalizeStyle({ backgroundColor: slotProps.value.colorHash })
                          }, null, 4),
                          _createElementVNode("div", null, _toDisplayString(slotProps.value.code), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(slotProps.placeholder), 1))
                  ]),
                  option: _withCtx((slotProps) => [
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("div", {
                        class: "color-box mr-2",
                        style: _normalizeStyle({ backgroundColor: slotProps.option.colorHash })
                      }, null, 4),
                      _createElementVNode("div", null, _toDisplayString(slotProps.option.code), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["disabled", "modelValue", "options", "class", "invalid"]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.selectedColor.$errors, (error, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "text-sm font-italic text-red-400"
                  }, _toDisplayString(error.$message), 1))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_37, [
                _hoisted_38,
                _createVNode(_component_InputText, {
                  class: "w-full",
                  disabled: !($data.selectedCategory.name && $data.selectedProduct.code),
                  modelValue: $data.stockItem.type,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($data.stockItem.type) = $event)),
                  type: "text",
                  name: "item-type",
                  id: "item-type"
                }, null, 8, ["disabled", "modelValue"])
              ]),
              _createElementVNode("div", _hoisted_39, [
                _hoisted_40,
                _createVNode(_component_InputText, {
                  class: "w-full",
                  disabled: !($data.selectedCategory.name && $data.selectedProduct.code),
                  modelValue: $data.stockItem.location,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($data.stockItem.location) = $event)),
                  type: "text",
                  name: "item-location",
                  id: "item-location"
                }, null, 8, ["disabled", "modelValue"])
              ]),
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, [
                  _createVNode(_component_PrimevueCheckbox, {
                    disabled: !($data.selectedCategory.name && $data.selectedProduct.code),
                    modelValue: $data.stockItem.wholePiece,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($data.stockItem.wholePiece) = $event)),
                    inputId: "wholePiece",
                    name: "wholePiece",
                    binary: true
                  }, null, 8, ["disabled", "modelValue"]),
                  _hoisted_43
                ])
              ])
            ])
          ]),
          _hoisted_44,
          _createElementVNode("div", _hoisted_45, [
            _createVNode(_component_PrimevueButton, {
              type: "submit",
              label: "Pridať kusy",
              text: "",
              raised: "",
              class: "uppercase"
            }),
            _createVNode(_component_router_link, { to: "/mod-stock/stock-items" }, {
              default: _withCtx(() => [
                _createVNode(_component_PrimevueButton, {
                  label: "Zrušiť",
                  severity: "danger",
                  text: "",
                  raised: "",
                  class: "uppercase"
                })
              ]),
              _: 1
            })
          ])
        ], 32)
      ]),
      _: 1
    }),
    _createVNode(_component_PrimevueDialog, {
      visible: this.visibleProducts,
      "onUpdate:visible": _cache[16] || (_cache[16] = ($event: any) => ((this.visibleProducts) = $event)),
      header: "Produkty",
      style: { width: '60rem' }
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_46, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.products, (prod, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "p-1 sm:col-12 md:col-4 lg:col-4 xl:col-4"
            }, [
              _createVNode(_component_PrimevueButton, {
                outlined: "",
                class: "p-1",
                onClick: ($event: any) => ($options.setSelectProduct(prod) ),
                onMouseover: ($event: any) => (this.hoverIndex = index),
                onMouseleave: _cache[15] || (_cache[15] = ($event: any) => (this.hoverIndex = null)),
                style: _normalizeStyle($options.buttonStyle(index))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("div", _hoisted_48, [
                      _createElementVNode("div", _hoisted_49, _toDisplayString(prod.code), 1),
                      _createElementVNode("div", _hoisted_50, _toDisplayString(prod.name), 1)
                    ]),
                    _createElementVNode("div", _hoisted_51, [
                      _createElementVNode("div", _hoisted_52, [
                        _createElementVNode("img", {
                          src: prod.image,
                          style: _normalizeStyle(`${prod.imageHeight >= prod.imageWidth ? 'height:168px;' : 'width:140px;'}`),
                          onLoad: ($event: any) => ($options.checkImageSize(index,$event)),
                          alt: "Preview Image",
                          class: ""
                        }, null, 44, _hoisted_53)
                      ])
                    ])
                  ])
                ]),
                _: 2
              }, 1032, ["onClick", "onMouseover", "style"])
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_ConfirmDialog)
  ]))
}